import { z } from 'zod';
import { InspectionJobSchema } from './jobs.js';
export const SchedulingOverviewSchema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}$/),
    metrics: z.object({
        booked: z.number().int().nonnegative(),
        upcoming: z.number().int().nonnegative(),
        completedOnsite: z.number().int().nonnegative(),
        overdue: z.number().int().nonnegative(),
        unassigned: z.number().int().nonnegative(),
        cancelled: z.number().int().nonnegative(),
        pvReportsExpected: z.number().int().nonnegative(),
        btyReportsExpected: z.number().int().nonnegative(),
        informationRequired: z.number().int().nonnegative(),
        revisitRequired: z.number().int().nonnegative(),
    }),
    inspectors: z.array(z.object({ inspectorId: z.string(), booked: z.number().int() })),
    options: z.object({
        clients: z.array(z.object({ clientId: z.string(), clientName: z.string() })),
        inspectors: z.array(z.string()),
    }),
    jobs: z.array(InspectionJobSchema),
    qaExceptions: z.array(z.object({
        jobId: z.string(),
        submittedAt: z.string(),
        inspectorId: z.string(),
        kind: z.enum(['information-required', 'revisit-required']),
    })),
});
//# sourceMappingURL=scheduling.js.map